import React, {useContext, useEffect, useState} from 'react'
import {
    AddRounded as AddIcon, IosShareRounded,
    RemoveRounded as RemoveIcon, ShareRounded
} from '@mui/icons-material'
import {IconButton, InputAdornment, TextField} from '@mui/material'
import {getLocal} from '../../../hooks/useStorage/useStorage.jsx'
import {ItemBagContext} from '../../../context/ItemBagContext.jsx'
import {itemBag as textsItemBag} from '../../../translate/Translate.jsx'
import {copy, isEmpty, isIOS} from 'react-lf-tools'

import './informationProduct.scss'

const InformationProduct = ({product, isCouponProduct, onClick, onMessage}) => {
    const {
        productQuantity,
        setProductQuantity,
        setQuantityFractioned,
        quantityFractioned,
        setAddItem,
        isAddItem,
        setSnackbar
    } = useContext(ItemBagContext)
    const allowFractioned = getLocal('allowFractioned', false)

    const [settings, setSettings] = useState({
        maximumQuantity: 100,
        minimumQuantity: 1
    })

    const handleClickAdd = () => {
        if ((productQuantity + 1) > settings.maximumQuantity) return setSnackbar({
            open: true,
            message: `${textsItemBag.maximumQuantity}"${settings.maximumQuantity}"`
        })
        setAddItem(!isAddItem)
        setProductQuantity((productQuantity + 1))
    }

    const handleClickRemove = () => {
        if ((settings.minimumQuantity !== 1) && (productQuantity <= settings.minimumQuantity)) return setSnackbar({
            open: true,
            message: `${textsItemBag.minimumQuantity}"${settings.minimumQuantity}"`
        })
        if (productQuantity !== 1) {
            setAddItem(!isAddItem)
            setProductQuantity((productQuantity - 1))
        }
    }

    const handleChange = e => {
        let value = e.target.value
        if (value === '') {
            setQuantityFractioned('')
            setProductQuantity(0)
        } else {
            value = value.replaceAll(',', '.')
            value = value.replace(/[^\w\s.]/gi, '')
            setQuantityFractioned(value)
            value = parseFloat(value)
            setProductQuantity(value)
        }
    }

    useEffect(() => checkQuantities(), [])

    const checkQuantities = () => {
        const maximumQuantityLocal = getLocal(`maximumQuantity=${product.sku}`)
        const maximumQuantity = (!isEmpty(maximumQuantityLocal)) ? maximumQuantityLocal : product.qtdeMax
        const minimumQuantity = (!isEmpty(product.qtdeMin)) ? product.qtdeMin : 1
        if (!isEmpty(product.qtdeMin)) {
            setProductQuantity(product.qtdeMin)
        }
        setSettings({
            maximumQuantity: maximumQuantity,
            minimumQuantity: minimumQuantity
        })
    }

    const handleClickShared = async (sku) => {
        const message = await copy(`${window.location.protocol}//${window.location.host}/${import.meta.env.VITE_BASE}?produto=${sku}`)
        onMessage(message)
    }

    return <div className={'container-information-product'}>
        <div className={'information-product'}>
            <div className={'div-name-share'}>
                <label className={'label-information-title-product'}>
                    {product.product}
                </label>
                <IconButton onClick={() => handleClickShared(product.sku)}>
                    {isIOS() ? <IosShareRounded className={'icon'}/> : <ShareRounded className={'icon'}/>}
                </IconButton>
            </div>
            {(() => {
                if (!isCouponProduct) {
                    if (product.fractioned && allowFractioned) {
                        return <div>
                            <TextField
                                value={quantityFractioned}
                                color={'secondary'}
                                type={'tel'}
                                placeholder={textsItemBag.quantity}
                                label={textsItemBag.quantity}
                                sx={{width: '150px'}}
                                InputProps={{
                                    startAdornment: <InputAdornment position={'start'}>
                                        kg
                                    </InputAdornment>
                                }}
                                onChange={handleChange}
                            />
                        </div>
                    } else {
                        return <div className={'div-amount-product'}>
                            <div className={'left'}>
                                <IconButton onClick={() => handleClickRemove()}>
                                    <RemoveIcon className={'icon-information'}/>
                                </IconButton>
                            </div>
                            <div className={'center'} onClick={onClick}>
                                <label className={'label-amount'}>
                                    {productQuantity}
                                </label>
                            </div>
                            <div className={'right'}>
                                <IconButton onClick={() => handleClickAdd()}>
                                    <AddIcon className={'icon-information'}/>
                                </IconButton>
                            </div>
                        </div>
                    }
                } else {
                    return <div/>
                }
            })()}
        </div>
        <div className={'div-description-product'}>
            {product.description.split('\n').map((d, i) => <label key={i} className={'label-description'}>
                {d}
            </label>)}
        </div>
    </div>
}

export default InformationProduct
